// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__bIMic","right":"Footer_right__d0XZ-","buttons":"Footer_buttons__3yCz9"};